import { Fragment } from 'react';

import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import { formatAmount } from '../../../../utils/format-amount.util';
import type { DevisPrestationsGroupRenderModel } from '../utils/build-devis-prestations-render-model.util';

import { DevisPrestationsUsageDetails } from './DevisPrestationsUsageDetails';

interface Props {
  readonly currenciesIdMap: MappedReferencesContext['currenciesIdMap'];
  readonly groups: readonly DevisPrestationsGroupRenderModel[];
  readonly unitsIdMap: MappedReferencesContext['unitsIdMap'];
  readonly vatsIdMap: MappedReferencesContext['vatsIdMap'];
}

export const DevisPrestationsServiceUsagesTable = ({
  currenciesIdMap,
  groups,
  unitsIdMap,
  vatsIdMap,
}: Readonly<Props>) => (
  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
      <tr>
        <th align="left">Description</th>
      </tr>
    </thead>
    <tbody>
      {groups.map((group) => (
        <Fragment key={group.id}>
          {group.sectionTitle ? (
            <tr>
              <td align="left">
                <strong>
                  <u>{group.sectionTitle}</u>
                </strong>
              </td>
            </tr>
          ) : null}
          {group.label ? (
            <tr>
              <td align="left">
                <strong>{group.label}</strong>
              </td>
            </tr>
          ) : null}
          {group.usages.map((usage) => (
            <tr key={usage.id}>
              <td align="left">
                <DevisPrestationsUsageDetails
                  currenciesIdMap={currenciesIdMap}
                  unitsIdMap={unitsIdMap}
                  usage={usage}
                  vatsIdMap={vatsIdMap}
                />
              </td>
            </tr>
          ))}
          {group.subtotal ? (
            <tr>
              <td align="left">
                Sous-total du groupe (HT) :{' '}
                {formatAmount(group.subtotal, currenciesIdMap)}
              </td>
            </tr>
          ) : null}
        </Fragment>
      ))}
    </tbody>
  </table>
);
